import {Component, EventEmitter, Input, OnInit, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatProgressBar} from "@angular/material/progress-bar";
import {MatSidenav, MatSidenavModule} from "@angular/material/sidenav";
import {CrudTableComponent} from "projects/nter-ui-kit/src/lib/webkit/components/crud-table/crud-table.component";
import {CrudItemComponent} from "projects/nter-ui-kit/src/lib/webkit/components/crud-item/crud-item.component";
import {
  generateDefaultSearchTerms,
  generateTableColumns
} from "projects/nter-ui-kit/src/lib/webkit/components/crud-item/crud-item-decorator";
import {
  AppTableDisplayColumn,
  TableActionItem
} from "projects/nter-ui-kit/src/lib/webkit/components/crud-table/crud-table.model";
import {LoadingService} from "projects/nter-ui-kit/src/lib/framework/util/service/loading.service";
import {SnackbarService} from "projects/nter-ui-kit/src/lib/framework/util/service/snackbar.service";

@Component({
  selector: 'app-master-detail-crud',
  standalone: true,
  imports: [CommonModule, CrudTableComponent, MatProgressBar, MatSidenavModule, CrudItemComponent],
  templateUrl: './master-detail-crud.component.html'
})
export class MasterDetailCrudComponent implements OnInit {
  @ViewChild(MatSidenav) sidenavContainer!: MatSidenav;
  @ViewChild(CrudItemComponent) crudItemComponent!: CrudItemComponent;

  protected loading$ = this._loader.loading$;

  @Input() formTitle!: string;
  @Input() formSubtitle!: string;
  @Input() tableTitle!: string;
  @Input() tableSubtitle!: string;

  //CRUD Table
  @Input() modelType!: any;
  @Input() apiEndpointRoot!: string;
  @Input() apiEndpointPOSTTemplate!: string;

  protected displayColumns: AppTableDisplayColumn[] = [];
  protected defaultFilters: string[] = [];
  protected selectedRow: any | null = null;
  protected updatedRow: any | null = null;

  // CRUD form
  protected apiEndpointPOST: string = '';
  addRowEventEmitter = new EventEmitter<any>();
  additionalActions: TableActionItem[] = [
    {
      label: 'Add',
      icon: 'add',
      eventEmitter: this.addRowEventEmitter,
      includeData: true,
      actionDataSource: 'EmptyRow',
      enabled: 'Always',
      keepSelectedRowOnClick: false,
    },
  ];

  constructor(private _loader: LoadingService, private _utils: SnackbarService) {
  }

  ngOnInit() {
    this.displayColumns = generateTableColumns(this.modelType);
    this.defaultFilters = generateDefaultSearchTerms(this.modelType);

    this.apiEndpointPOST = this.apiEndpointRoot + this.apiEndpointPOSTTemplate;

    this.addRowEventEmitter.subscribe((event: any) => {
      this.rowSelected(event);
    });
  }

  rowSelected($event: any) {
    const hasData: boolean = $event ?? false;
    this.selectedRow = new this.modelType($event)
    this.sidenavContainer.toggle(hasData);
  }

  handleFormSubmission($event: any) {
    if ($event.data) {
      this.updatedRow = new this.modelType($event.data);
    }
  }

  get pendingChanges() {
    return this.crudItemComponent?.pendingChanges ?? false;
  }

  handleGracefulClose() {
    if (this.pendingChanges) {
      this._utils.openSnackBar("There are pending changes, please save or discard before closing");
      return;
    }
    this.rowSelected(null);
  }

}

